import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { useToggleClientInformationDrawerCallback } from '../client-information';
import { hasAnyNewFormsAtom } from '../client-information/state';
import { useTrackClientInfoClicked } from '../client-information/useTrackClientInfoClicked';
import { drawerStateAtom, inSessionPatientInformationAtom } from '../state';
import { getIsClientInfoDrawerOpen } from '../utils';
import { ClientInformationDrawerControlMenuItem } from './ClientInformationDrawerControlMenuItem';

export function ClientInformationDrawerControlMenuItemWrapper() {
  const isClientInfoDrawerOpen = getIsClientInfoDrawerOpen(useAtomValue(drawerStateAtom));
  const toggleClientInformationDrawer = useToggleClientInformationDrawerCallback();
  const inSessionClientInformation = useAtomValue(inSessionPatientInformationAtom);
  const trackClientInfoClicked = useTrackClientInfoClicked(inSessionClientInformation?.patientShortId);
  const onClick = useCallback(() => {
    if (!inSessionClientInformation) {
      return;
    }
    const isOpening = !isClientInfoDrawerOpen;
    toggleClientInformationDrawer({
      visitorUuid: inSessionClientInformation.visitorUuid,
      patientShortId: inSessionClientInformation.patientShortId,
    });
    if (isOpening) {
      void trackClientInfoClicked('overflow_menu');
    }
  }, [inSessionClientInformation, isClientInfoDrawerOpen, toggleClientInformationDrawer, trackClientInfoClicked]);
  const hasNewForms = useAtomValue(hasAnyNewFormsAtom);

  return (
    <ClientInformationDrawerControlMenuItem
      isClientInfoDrawerOpen={isClientInfoDrawerOpen}
      hasNewClientInfo={hasNewForms}
      onClick={onClick}
    />
  );
}
